import { AssessmentType } from '../constants-types/Enums';

// Yeah, that's right. I don't like classical inheritance

export interface Assessment {
    id?: string;
    completedDate: Date;
    type?: AssessmentType;
}

export enum InvitationSource {
    Unknown = 0,
    AssessmentCenter,
    Design,
    SelfService,
    Hire,
    Design2,
    Inspire2,
    Admin,
    Perform,
    ATS,
    Dashboard2
}

export enum BAInvitationQueryParam {
    Hire = 'hh',
    Inspire = 'inspire'
}
